import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { Excavation } from '@paragon/contract-library';

export type CanaryDownloadInfo = { readonly recording: boolean; readonly excavations: readonly Excavation[] };

const initialState: CanaryDownloadInfo = {
  recording: false,
  excavations: [],
};

const canaryDownloadSlice = createSlice({
  name: 'canaryDownload',
  initialState,
  reducers: {
    startCanaryRecording: () => ({
      recording: true,
      excavations: [],
    }),
    endCanaryRecording: (state) => {
      state.recording = true;
    },
    addCanaryExcavation: (state, action: PayloadAction<Excavation>) => {
      state.excavations.push(castDraft(action.payload));
    },
    addCanaryExcavations: (state, action: PayloadAction<readonly Excavation[]>) => {
      for (const excavation of action.payload) {
        state.excavations.push(castDraft(excavation));
      }
    },
  },
});

export const { startCanaryRecording, endCanaryRecording, addCanaryExcavation, addCanaryExcavations } =
  canaryDownloadSlice.actions;
export const canaryDownload = canaryDownloadSlice.reducer;
